export const Environment = {
    DEVELOPMENT: "Environment.DEVELOPMENT",
    RELEASE: "Environment.RELEASE",
    PRODUCTION: "Environment.PRODUCTION",
};